import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { PaginationResponse } from "@/core/services/api/interfaces/PaginationResponse";
import ApiService from "@/core/services/ApiService";
import { AxiosRequestConfig } from "axios";
import { CompanyProduct } from "@/core/services/api/interfaces/common/CompanyProduct";
import router from "@/router";

@Module
export default class CompanyProductsModule extends VuexModule {
  pagination = new PaginationResponse<CompanyProduct>();
  loading = false;

  get companyProducts(): CompanyProduct[] {
    return this.pagination.data;
  }

  get companyProductsLoading(): boolean {
    return this.loading;
  }

  get getProductURL() {
    return (product_hash: string) => {
      return `${process.env.VUE_APP_URL}${
        router.resolve({
          name: "guest.products.purchase",
          params: { product_hash: product_hash },
        }).href
      }`;
    };
  }

  get companyProductsPagination(): PaginationResponse<CompanyProduct> {
    return this.pagination;
  }

  get companyProductsTotal(): number {
    return this.pagination.total;
  }

  get companyProductsRequired(): boolean {
    return !this.pagination.total && !this.loading;
  }

  get companyProductsCurrentPage(): number {
    return this.pagination.current_page;
  }

  get companyProductsPerPage(): number {
    return this.pagination.per_page;
  }

  @Action({ rawError: true })
  [Actions.MANAGER_COMPANY_PRODUCTS_UPDATE_IMAGE]({ id, file }) {
    return ApiService.manager.product
      .updateImage(id, file)
      .then(ApiService.unwrapItemResponse);
  }

  @Action({ rawError: true })
  [Actions.MANAGER_COMPANY_PRODUCTS_LOAD](params) {
    this.context.commit(Mutations.MANAGER_COMPANY_PRODUCTS_SET_LOADING, true);

    return ApiService.manager.product
      .list({
        params: params,
      } as AxiosRequestConfig)
      .then(ApiService.unwrapPaginationResponse)
      .then((response) => {
        this.context.commit(Mutations.MANAGER_COMPANY_PRODUCTS_SET, response);
      })
      .catch(console.error)
      .finally(() => {
        this.context.commit(
          Mutations.MANAGER_COMPANY_PRODUCTS_SET_LOADING,
          false
        );

        this.context.commit(
          Mutations.COMMON_REQUEST_DONE,
          Actions.MANAGER_COMPANY_PRODUCTS_LOAD
        );
      });
  }

  @Action({ rawError: true })
  async [Actions.MANAGER_COMPANY_PRODUCTS_VIEW](id: number) {
    this.context.commit(Mutations.MANAGER_COMPANY_PRODUCTS_SET_LOADING, true);
    for (const i in this.pagination.data) {
      const product = this.pagination.data[i];

      if (product.id === id) {
        this.context.commit(
          Mutations.MANAGER_COMPANY_PRODUCTS_SET_LOADING,
          false
        );

        return product;
      }
    }

    const product = await ApiService.manager.product
      .view(id)
      .then(ApiService.unwrapItemResponse)
      .catch((e) => {
        console.error(e);

        return null;
      });
    this.context.commit(Mutations.MANAGER_COMPANY_PRODUCTS_SET_LOADING, false);

    return product;
  }

  @Action({ rawError: true })
  [Actions.MANAGER_COMPANY_PRODUCTS_CREATE](params) {
    this.context.commit(Mutations.MANAGER_COMPANY_PRODUCTS_SET_LOADING, true);

    return ApiService.manager.product
      .create(params)
      .then(ApiService.unwrapItemResponse)
      .finally(() =>
        this.context.commit(
          Mutations.MANAGER_COMPANY_PRODUCTS_SET_LOADING,
          false
        )
      );
  }

  @Action({ rawError: true })
  [Actions.MANAGER_COMPANY_PRODUCTS_UPDATE]({ id, params }) {
    this.context.commit(Mutations.MANAGER_COMPANY_PRODUCTS_SET_LOADING, true);
    console.log(id, params);

    return ApiService.manager.product
      .update(id, params)
      .then(ApiService.unwrapItemResponse)
      .finally(() =>
        this.context.commit(
          Mutations.MANAGER_COMPANY_PRODUCTS_SET_LOADING,
          false
        )
      );
  }

  @Mutation
  [Mutations.MANAGER_COMPANY_PRODUCTS_RESET]() {
    this.pagination = new PaginationResponse<CompanyProduct>();
  }

  @Mutation
  [Mutations.MANAGER_COMPANY_PRODUCTS_SET](
    pagination: PaginationResponse<CompanyProduct>
  ) {
    this.pagination = pagination;
  }

  @Mutation
  [Mutations.MANAGER_COMPANY_PRODUCTS_SET_LOADING](loading: boolean) {
    this.loading = loading;
  }
}
